import { displaySpec } from "./equipmentIndex";

export function summaryDescription(summary, limit = 155) {
  const text = String(summary).replace(/\s+/g, " ").trim();
  if (text.length <= limit) return text;
  const room = limit - 1;
  const clipped = text.slice(0, room);
  const boundary = clipped.lastIndexOf(" ");
  const word = (boundary > 0 ? clipped.slice(0, boundary) : clipped).replace(/[\s,;:.]+$/, "");
  return `${word}…`;
}

function indefinite(label) {
  return /^[aeiou]/i.test(label) ? "an" : "a";
}

export function keyFactsText(robot) {
  const navigation = displaySpec(robot.navigation);
  const sentences = [
    `${robot.vendor} manufactures the ${robot.model} as ${indefinite(robot.typeLabel)} ${robot.typeLabel}.`,
    `The published payload of the ${robot.model} is ${displaySpec(robot.payloadKg, "kg")}.`,
    navigation === "Not published"
      ? `${robot.vendor} does not publish a navigation method for the ${robot.model}.`
      : `The ${robot.model} navigates with ${navigation}.`,
    robot.magDeployed
      ? `MAG has deployed the ${robot.model}.`
      : `MAG has not deployed the ${robot.model}.`,
  ];
  return sentences.join(" ");
}

export function publishedFaqs(robot) {
  if (!Array.isArray(robot.faq)) return [];
  return robot.faq.filter((item) => item && String(item.question || "").trim() && String(item.answer || "").trim());
}

export function relatedMachines(robot, robots, count = 3) {
  const others = robots.filter((item) => item.slug !== robot.slug);
  const rank = (list) => list
    .map((item, index) => ({
      item,
      index,
      distance: Math.abs(item.payloadKg - robot.payloadKg),
    }))
    .sort((left, right) => left.distance - right.distance || left.index - right.index)
    .map((entry) => entry.item);
  const sameType = rank(others.filter((item) => item.type === robot.type));
  const otherTypes = rank(others.filter((item) => item.type !== robot.type));
  return [...sameType, ...otherTypes].slice(0, count);
}

export const CONFIGURATION_DISCLAIMER = "Specifications reflect a standard configuration and are subject to change by the manufacturer. Optional masts, attachments, batteries, and navigation modes can change rated capacity and performance. MAG confirms as-configured specifications during site assessment.";
